<template>
	<div class="fund-record page">
		<van-nav-bar title="资金记录" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>

		<div class="record-tabs">
			<button
				v-for="item in tabs"
				:key="item.key"
				type="button"
				:class="{ active: activeTab === item.key }"
				@click="changeTab(item.key)"
			>
				{{ item.label }}
			</button>
		</div>

		<div class="record-body">
			<van-loading v-if="loading" class="record-loading" color="#e63fbc" />
			<van-empty v-else-if="currentList.length === 0" description="暂无记录" />
			<div v-else class="record-list">
				<div v-for="item in currentList" :key="item.id || item.order_no || item.create_time" class="record-card">
					<div class="record-top">
						<div>
							<strong :class="{ plus: isPlus(item), minus: isMinus(item) }">{{ amountText(item) }}</strong>
							<span>{{ titleText(item) }}</span>
						</div>
						<em :class="'status status-' + statusValue(item)">{{ statusText(item) }}</em>
					</div>
					<div class="record-row" v-if="item.order_no">
						<span>订单号</span>
						<p>{{ item.order_no }}</p>
					</div>
					<div class="record-row">
						<span>时间</span>
						<p>{{ item.create_time || item.pay_time || item.update_time || '-' }}</p>
					</div>
					<div class="record-row" v-if="item.desc || item.remark">
						<span>说明</span>
						<p>{{ item.desc || item.remark }}</p>
					</div>
					<div class="record-row" v-if="activeTab === 'fund'">
						<span>变动前</span>
						<p>{{ item.before_money || '-' }}</p>
					</div>
					<div class="record-row" v-if="activeTab === 'fund'">
						<span>变动后</span>
						<p>{{ item.after_money || '-' }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			activeTab: 'recharge',
			loading: false,
			lists: {
				recharge: [],
				withdraw: [],
				fund: []
			},
			loaded: {
				recharge: false,
				withdraw: false,
				fund: false
			},
			tabs: [
				{ key: 'recharge', label: '充值记录', api: 'user_get_recharge_list' },
				{ key: 'withdraw', label: '提现记录', api: 'user_get_withdraw_list' },
				{ key: 'fund', label: '资金日志', api: 'user_get_fund_log' }
			]
		};
	},
	computed: {
		currentList() {
			return this.lists[this.activeTab] || [];
		},
		currentTab() {
			return this.tabs.find(item => item.key === this.activeTab) || this.tabs[0];
		}
	},
	methods: {
		back() {
			return window.history.back();
		},
		changeTab(key) {
			this.activeTab = key;
			if (!this.loaded[key]) {
				this.getList();
			}
		},
		getList() {
			const tab = this.currentTab;
			this.loading = true;
			this.$http({
				method: 'get',
				url: tab.api
			}).then(res => {
				this.loading = false;
				if (res.code === 200) {
					this.lists[this.activeTab] = this.normalizeList(res.data);
					this.loaded[this.activeTab] = true;
				} else {
					this.lists[this.activeTab] = [];
					this.$toast(res.msg || '记录获取失败');
				}
			}).catch(() => {
				this.loading = false;
				this.lists[this.activeTab] = [];
				this.$toast.fail('记录获取失败');
			});
		},
		normalizeList(data) {
			if (Array.isArray(data)) {
				return data;
			}
			if (data && Array.isArray(data.list)) {
				return data.list;
			}
			return [];
		},
		statusValue(item) {
			if (item.status !== undefined && item.status !== null && item.status !== '') {
				return Number(item.status);
			}
			if (item.direction === 'income' || item.type === 'in' || item.change_type === 'in') {
				return 2;
			}
			if (item.direction === 'expense' || item.direction === 'outcome' || item.type === 'out' || item.change_type === 'out') {
				return 3;
			}
			return 0;
		},
		statusText(item) {
			const map = {
				0: '未支付',
				1: '待审核',
				2: '已通过',
				3: '已拒绝'
			};
			if (this.activeTab === 'fund') {
				return item.direction_text || item.type_text || item.change_type_text || item.status_text || '资金变动';
			}
			return item.status_text || map[this.statusValue(item)] || '未知状态';
		},
		titleText(item) {
			if (this.activeTab === 'recharge') {
				return item.pay_title || item.pay_way || '充值';
			}
			if (this.activeTab === 'withdraw') {
				return item.bank_name || item.desc || '提现';
			}
			return item.title || item.type_text || item.change_type_text || item.desc || '资金日志';
		},
		amountText(item) {
			const money = item.money || item.amount || item.change_money || '0.00';
			if (this.activeTab === 'withdraw') {
				return '-' + money;
			}
			if (this.activeTab === 'fund') {
				if (this.isMinus(item)) {
					return '-' + money;
				}
				if (this.isPlus(item)) {
					return '+' + money;
				}
			}
			return '+' + money;
		},
		isPlus(item) {
			return this.activeTab === 'recharge' || item.direction === 'income' || item.type === 'in' || item.change_type === 'in' || Number(item.is_add) === 1;
		},
		isMinus(item) {
			return this.activeTab === 'withdraw' || item.direction === 'expense' || item.direction === 'outcome' || item.type === 'out' || item.change_type === 'out' || Number(item.is_add) === 0;
		}
	},
	created() {
		if (!localStorage.getItem('token')) {
			this.$router.push({ path: '/Login' });
		} else {
			this.getList();
		}
	}
};
</script>

<style lang="less" scoped>
.fund-record {
	min-height: 100vh;
	background: #29243d;
	color: #fff;
}

.nav-bar {
	background: #29243d;
}

::v-deep .van-nav-bar__content {
	height: 100px;
}

::v-deep .van-nav-bar__title {
	color: #fff;
	font-size: 32px;
}

.record-tabs {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 10px;
	padding: 18px 22px;
}

.record-tabs button {
	height: 64px;
	border: 1px solid rgba(255, 255, 255, .08);
	border-radius: 8px;
	background: #342e4c;
	color: #cfc7e6;
	font-size: 24px;
}

.record-tabs button.active {
	border-color: rgba(243, 160, 223, .68);
	background: linear-gradient(135deg, rgba(125, 92, 255, .32), rgba(210, 95, 180, .32));
	color: #fff;
	font-weight: 700;
}

.record-body {
	padding: 0 22px 36px;
}

.record-loading {
	margin-top: 90px;
}

.record-card {
	padding: 20px;
	border-radius: 8px;
	background: #342e4c;
}

.record-card + .record-card {
	margin-top: 16px;
}

.record-top {
	display: flex;
	justify-content: space-between;
	gap: 14px;
	margin-bottom: 16px;
}

.record-top strong {
	display: block;
	font-size: 34px;
	line-height: 40px;
}

.record-top strong.plus {
	color: #70e0a0;
}

.record-top strong.minus {
	color: #ff8ba0;
}

.record-top span {
	display: block;
	margin-top: 6px;
	color: #cfc7e6;
	font-size: 22px;
}

.status {
	flex: 0 0 auto;
	min-width: 96px;
	height: 40px;
	padding: 0 12px;
	border-radius: 999px;
	font-style: normal;
	font-size: 22px;
	line-height: 40px;
	text-align: center;
}

.status-0 {
	color: #d7d0ea;
	background: rgba(215, 208, 234, .14);
}

.status-1 {
	color: #ffd36e;
	background: rgba(255, 211, 110, .14);
}

.status-2 {
	color: #70e0a0;
	background: rgba(112, 224, 160, .14);
}

.status-3 {
	color: #ff8ba0;
	background: rgba(255, 139, 160, .14);
}

.record-row {
	display: flex;
	gap: 12px;
	font-size: 22px;
	line-height: 32px;
}

.record-row + .record-row {
	margin-top: 8px;
}

.record-row span {
	flex: 0 0 92px;
	color: #cfc7e6;
}

.record-row p {
	flex: 1;
	margin: 0;
	color: #fff;
	word-break: break-all;
}

::v-deep .van-empty__description {
	color: #cfc7e6;
}
</style>
